export default {
  datumZmenyOd: null,
  datumZmenyDo: null,
  stadium: null,
  typ: null,
  oblastList: [],
  searchTextVyraz: '',
  searchTextCislo: '',
  searchTextRezort: '',
  searchTextNazov: '',
  searchTextRocnik: '',
  predkladatel: null,
  institucia: null,
};
